<template>
  <div class="warn-wrap">
    <v-container>
      <div>
        <v-img
          :src="require('../../assets/warning.png')"
          contain
          height="30vh"
        />
      </div>
      <v-row class="row">
        <div>네트워크에 접속할 수 없습니다.</div>
      </v-row>
      <v-row class="row">
        <div>연결 상태를 확인 후 다시 시도해 주세요.</div>
      </v-row>
      <v-row class="row">
        <div><v-btn class="reCon" @click="onReConnect">재시도</v-btn></div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  methods: {
    onReConnect() {
      this.$emit('@onReConnect')
    },
  },
})
</script>

<style scoped>
.warn-wrap {
  display: grid;
  place-items: center;
  min-height: 100dvh;
}
.row {
  margin: 1rem;
  justify-content: center;
  display: flex;
}
div {
  font-weight: bold;
  font-size: 20px;
}
.reCon {
  background-color: #303657;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  border-radius: 5px;
  padding: 8px;
  margin: 5px;
  width: 130px;
  display: flex;
  flex-wrap: wrap;
}
</style>
